import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  toasts: []
}

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, action) => {
      const { id, message, type = 'info', duration = 3000 } = action.payload
      state.toasts.push({
        id: id || Date.now(),
        message,
        type,
        duration,
        timestamp: Date.now()
      })
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter(toast => toast.id !== action.payload)
    },
    clearAllToasts: (state) => {
      state.toasts = []
    }
  }
})

export const { addToast, removeToast, clearAllToasts } = toastSlice.actions
export default toastSlice.reducer